import React, { useMemo } from "react";
import { format } from "date-fns";
import { useTable, useSortBy, useRowSelect } from "react-table";
import { IoMdArrowDropup, IoMdArrowDropdown } from "react-icons/io";
import { COLUMNS } from "./Columns";
import Loading from "../material-ui/Loading";
import CheckBox from "./CheckBox";
import Dropdown from "./Dropdown";
import { fileIcon } from "../common/FileIcons";
import "../../styles/Table.css";
import DeleteDocumentPopup from "../document-table/DeleteDocumentPopup";
import { AiOutlineEye } from "react-icons/ai";

const Table = ({
  loading,
  openFilter,
  documentTableData,
  addDocumentTab,
  getAllDataFunc,
  docsCount,
  setDocumentDeletedToTrue,
  isAdmin,
}) => {
  const columns = useMemo(() => COLUMNS, []);
  const data = useMemo(
    () =>
      documentTableData.map((table) => {
        return table;
      }),
    [documentTableData],
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    getToggleAllRowsSelectedProps,
  } = useTable(
    {
      columns: columns,
      data: data,
      initialState: {
        hiddenColumns: ["bg_color"],
      },
    },
    useSortBy,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => {
        return [
          {
            id: "selection",
            Cell: ({ row }) => (
              <>
                <CheckBox {...row.getToggleRowSelectedProps()} />
              </>
            ),
          },
          ...columns,
          ...(isAdmin != "2"
            ? [
                {
                  Header: "Actions",
                  id: "actions",
                  Cell: ({ row }) => {
                    const ext = row.original.extension?.toLowerCase();
                    const canView = ["pdf", "jpg", "jpeg", "png"].includes(ext);

                    return (
                      <div className="action-buttons">
                        {canView && (
                          <button
                            type="button"
                            className="eye-action"
                            onClick={() => addDocumentTab(row.original)}
                          >
                            <AiOutlineEye size={18} />
                          </button>
                        )}

                        <div className="delete-action">
                          <DeleteDocumentPopup
                            id={row.original.id}
                            setDocumentDeletedToTrue={setDocumentDeletedToTrue}
                            tableValues={row.original}
                          />
                        </div>
                      </div>
                    );
                  },
                }
              ]
            : []),
        ];
      });
    },
  );

  const selectedFlatRowsID = selectedFlatRows.map((row) => {
    return {
      title: row.values.title || "N/A",
      extension: row.values.extension || "N/A",
      date_entered:
        row.values.date_entered &&
        row.values.date_entered !== "0000-00-00 00:00:00"
          ? format(new Date(row.values.date_entered), "MM-dd-yyyy HH:mm")
          : "N/A",
      date_modified:
        row.values.date_modified &&
        row.values.date_modified !== "0000-00-00 00:00:00"
          ? format(new Date(row.values.date_modified), "MM-dd-yyyy HH:mm")
          : "N/A",
      case_number: row.values.case_number || "N/A",
      modified_user_name: row.values.modified_user_name || "N/A",
    };
  });

  const SelectionHeader = ({ getToggleAllRowsSelectedProps }) => {
    return (
      <div className="bulk-func">
        <CheckBox {...getToggleAllRowsSelectedProps()} />
        <Dropdown
          selectedRows={selectedFlatRowsID}
          getAllDataFunc={getAllDataFunc}
          docsCount={docsCount}
        />
      </div>
    );
  };

  return (
    <div className={!openFilter ? "table-content" : "resized-table-content"}>
      {!loading ? (
        <table className="documents-table report-table" {...getTableProps()}>
          <thead className="documents-table-header">
            {headerGroups.map((headerGroup, index) => (
              <tr
                className="documents-table-header-row"
                key={index}
                {...headerGroup.getHeaderGroupProps()}
              >
                {headerGroup.headers.map((column, index) => {
                  return (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className="documents-table-header-data"
                      key={index}
                    >
                      <span className="document-table-select-row">
                        {column.id === "selection" ? (
                          <SelectionHeader
                            getToggleAllRowsSelectedProps={
                              getToggleAllRowsSelectedProps
                            }
                          />
                        ) : (
                          <span
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "5px",
                            }}
                          >
                            {column.render("Header")}
                            <span
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                gap: "5px",
                                fontSize: "16px",
                              }}
                            >
                              {column.isSorted ? (
                                column.isSortedDesc ? (
                                  <IoMdArrowDropdown />
                                ) : (
                                  <IoMdArrowDropup />
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </span>
                        )}
                      </span>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>

          <tbody className="documents-table-body" {...getTableBodyProps()}>
            {rows.map((row, index) => {
              prepareRow(row);

              return (
                <tr
                  key={index}
                  className="document-table-body-row"
                  {...row.getRowProps()}
                >
                  {row.cells.map((cell, index) => {
                    switch (cell.column.Header) {
                      case "Case ID":
                        return (
                          <td key={index}>
                            {cell.value !== "" ? cell.value : "N/A"}
                          </td>
                        );

                      //   case "File Type":
                      //     return (
                      //       <td key={index} className="file-type-cell">
                      //         <span className="file-icon">
                      //           {fileIcon[cell.value?.toLowerCase()] || null}
                      //         </span>
                      //         {/* <span>{cell.value ? cell.value.toLowerCase() : "n/a"}</span> */}
                      //       </td>
                      //     );

                      case "File Type":
                        return (
                          <td
                            key={index}
                            className="file-type-cell"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              const ext =
                                cell.row.values.extension?.toLowerCase();
                              if (["pdf", "jpg", "jpeg", "png"].includes(ext)) {
                                // addDocumentTab(cell.row.values);
                                console.log("row.original:", row.original);
                                console.log(
                                  "cell.row.values:",
                                  cell.row.values,
                                );
                                addDocumentTab(row.original);
                              }
                            }}
                          >
                            <span className="file-icon">
                              {fileIcon[cell.value?.toLowerCase()] || null}
                            </span>
                          </td>
                        );

                      case "Category":
                        return (
                          <td key={index}>
                            <p
                              className="category"
                              style={{
                                background:
                                  cell.row.values.bg_color || "#4CAF50",
                                color: "white",
                              }}
                            >
                              {cell.row.values.category || "Form 8821"}
                            </p>
                          </td>
                        );

                      case "Date Entered":
                        return (
                          <td key={index}>
                            {cell.value &&
                            cell.value !== "0000-00-00" &&
                            cell.value !== "0000-00-00 00:00:00"
                              ? format(new Date(cell.value), "MM-dd-yyyy HH:mm")
                              : "N/A"}
                          </td>
                        );

                      case "Date Modified":
                        return (
                          <td key={index}>
                            {cell.value &&
                            cell.value !== "0000-00-00" &&
                            cell.value !== "0000-00-00 00:00:00"
                              ? format(new Date(cell.value), "MM-dd-yyyy HH:mm")
                              : "N/A"}
                          </td>
                        );

                      case "Status":
                        return <td key={index}>{cell.value || "N/A"}</td>;

                      case "Modified By":
                        return <td key={index}>{cell.value || "N/A"}</td>;

                      //   case "File Name":
                      //     return (
                      //       <td key={index} style={{ textAlign: "left" }}>
                      //         {cell.value || "N/A"}
                      //       </td>
                      //     );

                      case "File Name":
                        return (
                          <td
                            key={index}
                            style={{ textAlign: "left", cursor: "pointer" }}
                            onClick={() => {
                              const ext =
                                cell.row.values.extension?.toLowerCase();
                              if (["pdf", "jpg", "jpeg", "png"].includes(ext)) {
                                console.log("row.original:", row.original);
                                console.log(
                                  "cell.row.values:",
                                  cell.row.values,
                                );
                                addDocumentTab(row.original);
                              }
                            }}
                          >
                            {cell.value || "N/A"}
                          </td>
                        );

                      default:
                        return (
                          <td key={index} {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default Table;
